import styled from 'styled-components'
import Sizes from 'builder/styles/sizes'
import { foldableSectionMixin } from 'builder/components/Section'

export const SectionContainer = styled.div`
  position: relative;
  ${foldableSectionMixin};
`

export const SectionContent = styled.div``

export const BannerContainer = styled.div`
  margin-top: ${Sizes.S};
`
